module.exports = __webpack_public_path__ + "img/video-poster-mobile.9963b78.webp";